<template>
  <div>
    <table-component />
  </div>
</template>

<script>
  import TableComponent from '@projects/components/imports-table';

  export default {
    components: { TableComponent }
  }
</script>

<style lang="scss" scoped>

</style>
